import { render, staticRenderFns } from "./AplikaceNastaveni.vue?vue&type=template&id=6f3149b1&"
import script from "./AplikaceNastaveni.vue?vue&type=script&lang=ts&"
export * from "./AplikaceNastaveni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports